<span class="c-dot-loader">
	<span></span>
	<span></span>
	<span></span>
</span>
